export const DEFAULT_AUDIO_TRACKS = [1, 2, 3, 4];

const cache = new Map();

export function audioTrackName(trackNumber) {
	return `Audio track ${trackNumber}`;
}

export function buildDvrArchiveHlsUrl(video, stream, from = video.from, duration = video.duration) {
	const range = `${from}-${duration}`;
	if (video.namedHls) {
		return `https://${video.server}/${video.episodeId}/archive-${range}.m3u8`;
	}
	const key = video.abr ? `ngrp:${stream.key}_all` : stream.key;
	if (stream.type === 'restream') {
		return `https://${video.server}/store/${key}/archive-${range}.m3u8`;
	}
	const prefix = video.abr ? 'edge-en' : 'edge';
	return `https://${video.server}/archives/${prefix}/${key}/archive-${range}.m3u8`;
}

// Audio can be listed as its own rendition (URI="tracks-a2/...") or muxed into a
// variant (tracks-v1a1/...), so every tracks-<selector> in the master is read.
export function parseAudioTrackNumbers(masterPlaylist) {
	const numbers = new Set();
	for (const [, selector] of masterPlaylist.matchAll(/tracks-((?:[a-z]\d+)+)/g)) {
		for (const [, number] of selector.matchAll(/a(\d+)/g)) {
			numbers.add(Number(number));
		}
	}
	return [...numbers].sort((a, b) => a - b);
}

// The DVR server answers 500 for an audio-only export of a track the recording
// does not have, so only tracks listed in the archive's HLS master are offered.
// Falls back to DEFAULT_AUDIO_TRACKS when the master cannot be read or parsed.
export function loadDvrAudioTracks(video, stream) {
	if (!video?.server) return Promise.resolve(DEFAULT_AUDIO_TRACKS);
	const url = buildDvrArchiveHlsUrl(video, stream);
	if (!cache.has(url)) {
		const request = fetch(url)
			.then((res) => (res.ok ? res.text() : ''))
			.then((text) => {
				const tracks = parseAudioTrackNumbers(text);
				return tracks.length ? tracks : DEFAULT_AUDIO_TRACKS;
			})
			.catch(() => {
				cache.delete(url);
				return DEFAULT_AUDIO_TRACKS;
			});
		cache.set(url, request);
	}
	return cache.get(url);
}
